export default __webpack_public_path__ + "static/media/press-banner.a981fbe9.JPG";